// src/stores/themeStore.js

import { defineStore } from "pinia";
import { ref } from "vue";

export const useThemeStore = defineStore("themeStore", () => {

  const theme = ref(localStorage.getItem("theme") || "dark");

  function applyTheme() {
    console.log("[ThemeStore] Applying theme:", theme.value); // ✅ Debug
    
    if (theme.value === "light") {
      document.body.classList.add("light-theme");
    } else {
      document.body.classList.remove("light-theme");
    }
  }

  function setTheme(t) {
    console.log("[ThemeStore] Setting theme:", t); // ✅ Debug
    
    theme.value = t;
    localStorage.setItem("theme", t);
    applyTheme();
  }

  // Apl aplica theme ao iniciar
  applyTheme();

  return {
    theme,
    setTheme,
    applyTheme
  };
});